import { injectAuthAPI } from '../..';
import { IContainer } from '../../interface/container';
import { injectFetch } from '../../interface/util';
import { IAuthManagerArguments, IAuthManagerInstantiator } from '../interface/auth';
import auth from './auth';

function bind(container: IContainer): IAuthManagerInstantiator {
    const authAPI = injectAuthAPI(container);

    return {
        open: (args: IAuthManagerArguments) => auth.open(authAPI, args),
        expand: (data: string) => auth.expand(authAPI, data),
    };
}

export default bind;
